module.exports = __webpack_public_path__ + "img/header-logo.bfddf569.png";